// extracted by mini-css-extract-plugin
export default {"container":"UvIAAmpqY2bbbJ0sGnDt"};